import { combineReducers } from 'redux';
import logoReducer from './LogoReducer/logoReducer';

export default combineReducers({
	logoReducer
});
